import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
// routes
import { RouterLink } from 'src/routes/components';
// config
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { paths } from 'src/routes/paths';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export default function LoginButton({ sx }) {

  const { user } = useMockedUser();


  return (
    <>
      {
        user ? <Button component={RouterLink} href={

          (user?.user_type === "1" && paths.superAdminDashboard.root) ||

          (user?.user_type === "2" && paths.adminDashboard.root) ||

          (user?.user_type === "3" && paths.dashboard.root) ||
          
          (user?.user_type === "4" && paths.dashboard.root)

        } color="primary" variant="contained" sx={{ mr: 1, ...sx }}>
          Dashboard
        </Button> :
          <Button component={RouterLink} href={'/'} color="primary" variant="contained" sx={{ px: 3, mr: 1, ...sx }}>
            Login
          </Button>
      }
    </>
  );
}

LoginButton.propTypes = {
  sx: PropTypes.object,
};


export function LoginButtonSmall({ sx }) {

  const { user } = useMockedUser();


  return (
    <Box sx={{ width: '100%', px: 2 }}>
      {
        user ? <Button fullWidth component={RouterLink} href={

          (user?.userType === "super-admin" && paths.superAdminDashboard.root) ||

          (user?.userType === "admin" && paths.adminDashboard.root) ||

          (user?.userType === "user" && paths.dashboard.root)
          
        } color="primary" variant="contained"
          sx={{ m: 1, ...sx }}>
          Dashboard
        </Button> :
          <Button fullWidth component={RouterLink} href={paths.auth.jwt.login} color="primary" variant="contained" sx={{ mr: 1, ...sx }}>
            Login
          </Button>
      }
    </Box>
  );
}

LoginButtonSmall.propTypes = {
  sx: PropTypes.object,
};
